<template>
  <div class="main">
    <!-- loading -->
    <div
      class="loadings"
      v-if="loading"
      v-loading="loading"
      :element-loading-text="loadingtext"
    ></div>
    <heads></heads>
    <banners></banners>
    <!-- <islogin /> -->
    <div class="content">
      <div class="cons">
        <!-- 生成标题0001 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">病理报告</div>
            <el-form-item label="hs">
              <el-input
                autosize
                type="textarea"
                v-model="form.hs"
              />
            </el-form-item>
            <el-form-item label="提交资料">
              <el-input
                autosize
                type="textarea"
                v-model="form.nr"
              />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="clickblbg()"
                >立即生成</el-button
              >
            </div>
            <el-form-item label="病理报告">
              <el-input
                autosize
                type="textarea"
                v-model="resultblbg"
              />
            </el-form-item>

          </el-form>
        </div>

      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { post } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, ref, inject, getCurrentInstance } from "vue";
import "echarts-wordcloud";
import { useRouter } from "vue-router";

const router = useRouter();
const { proxy } = getCurrentInstance();

const baseurls = "http://server-1:8055";

// loading
let loading = ref(false);
let loadingtext = ref("系统分析中，请等待...");

let form=reactive({
  hs:`1.请参考提供的资料，整理并分析这个病例报告。
2.输出格式：
报告名称： 1例XXX患者的诊治病例分析
一、患者基本情况
患者姓名、年龄、既往病史，用药史，无过敏史。
近期发病症状，近期就诊情况
生命体征稳定，临床症状表现。
入院后疾病初步诊断情况。
二、XX疾病常见病因
1、XXX
２、XXX
３、XXX
三、患者入院后处理情况
体格检查：
辅助检查：
疾病确诊情况
四、治疗和处置方案：
1、XXX（详细的药品名称，用法，剂量，作用等。简单描述300字）
２、XXX（详细的药品名称，用法，剂量，作用等。简单描述300字）
３、XXX（详细的药品名称，用法，剂量，作用等。简单描述300字）
4、在治疗过程中，患者生命体征变化：如呼吸、心率、血压、体温、血氧饱和度等，并阐述根据病情变化后的调整治疗和护理方案（简单描述800字）。
5、治疗和护理后的症状变化情况、生命体征平稳、精神状态等（简单描述600字）。
6、出院医嘱情况（简单描述500字）
五、患者治疗的主要问题
1、（简单描述300字）
2、（简单描述300字）
3、（简单描述300字）
六、针对主要问题采取的措施
1、（简单描述300字）
2、（简单描述300字）
3、（简单描述300字）
4、出院指导（简单描述300字）
七、讨论分析
1、（简单描述300字）
2、（简单描述300字）
3、（简单描述300字）
综上所述，（简单描述800字）

提交资料如下：报告内容:`,
  nr:'',
})
let resultblbg=ref('')
// 生成标题
const clickblbg = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form.hs+form.nr,
  })
    .then((res) => {
      loading.value = false;
      resultblbg.value = res.data;
    })
    .catch((err) => {
      loading.value = false;
    });
};

</script>

<style scoped>
:deep(.el-form-item__label) {
  background: #f5f7fa;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
}
:deep(.cons-form .el-input__inner) {
  height: 40px;
  font-size: 18px;
}
:deep(.cons-form .el-textarea__inner) {
  min-height: 100px !important;
  font-size: 18px;
}
:deep(.cons-form .el-button) {
  width: auto;
  height: 50px;
  font-size: 18px;
}
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
}
.cons {
  width: 1200px;
  margin: auto;
  padding: 30px 0;
}
.cons-form {
  width: 100%;
}
.cons-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.cons-subtitle {
  width: 100%;
  padding: 10px 30px;
  box-sizing: border-box;
  background: #f5f7fa;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin: auto;
  margin-bottom: 30px;
}
.custom-block {
  padding: 10px 16px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 5px solid #409eff;
  margin: 20px 0 20px 0;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-btn {
  text-align: center;
  margin-bottom: 30px;
}
.cons-title-subtitle {
  color: #999;
  font-size: 14px;
}
.cons-title-subtitle p {
  margin: 0;
  padding: 0;
  text-align: center;
}
.qksx-list-con {
  font-size: 14px;
  padding: 20px 0 0 0;
}
.qksx-list-con:after {
  content: "";
  display: table;
  clear: both;
}
.xsqk-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xsqk-list {
  cursor: pointer;
}
.xsqk-list-title {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.xsfx,
#echartsyyy {
  width: 1200px;
  height: 600px;
}
.loadings {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
</style>
